<div id="preloader">
    <div class="loader3">
        <span></span>
        <span></span>
    </div>
</div>